import { toast } from "vue3-toastify";

export function useBranchReminder() {
  const branchStore = useBranchStore();
  const authStore = useAuthStore();

  function startBranchReminder() {
    if (branchStore.branchReminderTimer || branchStore.reminderShown || !authStore.is_authenticated) return;

    const { defaultBranch, lastSavedBranch } = branchStore;

    if (!defaultBranch?.name || !lastSavedBranch?.name) return;
    if (defaultBranch.name === lastSavedBranch.name) return;

    branchStore.branchReminderTimer = setTimeout(() => {
      toast(
        useTranslation(
          "branchSwitchReminder",
          `${defaultBranch.name} is uw standaardbranch. Als u wilt terugschakelen naar ${defaultBranch.name}.`
        ),
        {
          autoClose: true,
          type: "info",
        }
      );

      branchStore.reminderShown = true;
      clearBranchReminder();
    }, 5 *60 * 1000);
  }

  function startBranchReminderForFirstTimeUser() {
    if (branchStore.branchReminderTimerId || branchStore.reminderShownForFirstTimeUser) return;
  
    const { defaultBranch, lastSavedBranch } = branchStore;
    if (defaultBranch?.name || lastSavedBranch?.name) return;

    branchStore.branchReminderTimerId = setTimeout(() => {
      toast(useTranslation('Toast-NotifyBranchSelect' , 'Wilt u de voorraad in onze vestiging bekijken, selecteer dan de dichtstbijzijnde vestiging.'), {
        autoClose: true,
        type: "success",
      });
      branchStore.reminderShownForFirstTimeUser = true;
      clearBranchReminderForFirstTimeUser();
    }, 2 *60 * 1000);
  }

  function clearBranchReminder() {
    if (branchStore.branchReminderTimer) {
      clearTimeout(branchStore.branchReminderTimer);
      branchStore.branchReminderTimer = null;
    }
  }

  function clearBranchReminderForFirstTimeUser() {
    if (branchStore.branchReminderTimerId) {
      clearTimeout(branchStore.branchReminderTimerId);
      branchStore.branchReminderTimerId = null;
    }
  } 

  return { startBranchReminder, clearBranchReminder, startBranchReminderForFirstTimeUser, clearBranchReminderForFirstTimeUser };
}
